export default "__VITE_ASSET__XPh0OUqh__"